<div class="box_image " [style.width]="size+'px'" [style.height]="size+'px'">
  mH
</div>